// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#007298","successColor":"#469c44","infoColor":"#0dcaf0","warningColor":"#df8a13","dangerColor":"#d9534f"};